module.exports = __webpack_public_path__ + "img/enroll-a-tank.ea73980f.svg";